// extracted by mini-css-extract-plugin
export default {"label":"frequency_selector-module___label___b81fc5bf"};